import React from 'react';
import logo from '../assets/logo.png';

function Landing({ onPortal, onLogin }) {
  return (
    <div className="min-h-screen bg-gray-950 flex flex-col items-center justify-center text-white p-6">
      
      {/* Logo */}
      <div className="mb-6">
        <img src={logo} alt="ArcBolt" width="80" />
      </div>

      {/* Brand name */}
      <div className="mb-2">
        <span className="text-4xl font-black text-yellow-400">Arc</span>
        <span className="text-4xl font-black text-white">Bolt</span>
      </div>
      <p className="text-xs text-gray-500 tracking-widest uppercase mb-10">Precision Trading Platform</p>

      {/* Portal cards */}
      <div className="grid grid-cols-2 gap-4 max-w-sm w-full mb-8">
        <div 
          onClick={() => onPortal('prep')}
          className="bg-gray-900 border border-gray-800 rounded-xl p-5 cursor-pointer hover:border-yellow-500 transition-all">
          <div className="text-2xl mb-2">⚡</div>
          <div className="text-sm font-semibold mb-1">PREP Signals</div>
          <div className="text-xs text-gray-500 mb-3">AI-powered Binance futures signals</div>
          <span className="text-xs bg-yellow-950 text-yellow-400 border border-yellow-800 px-2 py-1 rounded">Binance Futures</span>
        </div>
        <div 
          onClick={() => onPortal('mt')}
          className="bg-gray-900 border border-gray-800 rounded-xl p-5 cursor-pointer hover:border-green-500 transition-all">
          <div className="text-2xl mb-2">🪞</div>
          <div className="text-sm font-semibold mb-1">MirrorTrade</div>
          <div className="text-xs text-gray-500 mb-3">Copy top Solana wallet trades</div>
          <span className="text-xs bg-green-950 text-green-400 border border-green-800 px-2 py-1 rounded">Solana</span>
        </div>
      </div>

      {/* Buttons */}
      <div className="flex gap-3 mb-8">
        <button 
          onClick={() => onPortal('prep')}
          className="bg-gradient-to-r from-yellow-500 to-pink-600 text-white font-semibold px-6 py-2.5 rounded-lg text-sm hover:opacity-90 transition-all">
          Create account
        </button>
        <button 
          onClick={onLogin}
          className="bg-transparent border border-gray-700 text-gray-400 font-semibold px-6 py-2.5 rounded-lg text-sm hover:border-yellow-500 hover:text-yellow-400 transition-all">
          Sign in
        </button>
      </div>

      {/* Disclaimer */}
      <p className="text-xs text-gray-700 max-w-xs text-center leading-relaxed">
        ArcBolt is a technology platform only. Nothing constitutes financial advice. All trading involves substantial risk.
      </p>

    </div>
  );
}

export default Landing;